import * as React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";
import { setTokenAsync } from "./sessionSlice";
import { useAppDispatch } from "../../app/hooks";
import {Fragment} from 'react';
import {Alert, Avatar, Box, Paper} from "@mui/material";
import {LockOutlined} from "@mui/icons-material";
import {avatarStyle, boxStyle, paperSignStyle} from "./style"
import LanguageSwitcher from '../../app/language-switcher/LanguageSwitcher';
import { useSearchParams } from 'react-router-dom';

export const OktaLogin = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    const establishSession = async () => {
      if (auth.isLoading) return;
      if (!auth.isAuthenticated) return;

      // Tokens are automatically kept up to date by oidc-client-ts
      await dispatch(
        setTokenAsync({
          accessToken: auth.user?.access_token || "",
          refreshToken: auth.user?.refresh_token || "",
        })
      );
    };

    establishSession().catch(console.error);
  }, [dispatch, auth.isLoading, auth.isAuthenticated, auth.user]);

  return (
    <Box sx={boxStyle}>
      {searchParams.get("reason") &&
        searchParams.get("reason") === "disconnect" && (
          <Alert
            severity="warning"
            style={{
              marginTop: "16px",
            }}
          >
            {t("loggedOutPleaseLogin")}
          </Alert>
        )}
      <Paper
        className="paperSign"
        sx={paperSignStyle}
      >
        <div style={{ position: "relative", top: "-5%", right: "-45%" }}>
          <LanguageSwitcher />
        </div>
        <Avatar
          className="avatar"
          sx={avatarStyle}
        >
          <LockOutlined />
        </Avatar>
        <Fragment>
          <Typography
            component="h1"
            variant="h5"
          >
            Okta SSO
          </Typography>
          <div style={{ marginTop: "16px" }}>
          {!auth.isAuthenticated ? (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className="Submit"
              onClick={() => {
                auth.signinRedirect({
                  extraQueryParams: {
                    kc_idp_hint: process.env.REACT_APP_KEYCLOAK_OKTA_IDP as string,
                  },
                });
              }}
            >
              Se connecter
            </Button>
          ) : (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className="Submit"
              onClick={() => {
                auth.signoutRedirect();
              }}
            >
              Se déconnecter
            </Button>
          )}

          </div>
        </Fragment>
      </Paper>
    </Box>
  );
};
